import React, { useRef, useState, useEffect, useMemo } from "react";
import { useSelector, useDispatch } from "react-redux";
import Breadcrumb from "../../components/public/Breadcrumbs";
import { Input, Select } from "../../../src/components/common";
import requestcompany from "../../assets/images/requestcompany.png";
import { ReactComponent as AuditFirm } from "../../assets/icons/auditFirm.svg";
import { ReactComponent as Spinner } from "../../assets/icons/spinner.svg";
import { ReactComponent as MapPoint } from "../../assets/icons/MapPoint.svg";
import { ReactComponent as Globus } from "../../assets/icons/Globus.svg";
import { ReactComponent as Email } from "../../assets/icons/email.svg";
import { ReactComponent as User } from "../../assets/icons/user.svg";
import { ReactComponent as Designation } from "../../assets/icons/auditFirm.svg";
import CompanyNotFoundBg from "../../assets/images/bgWidget.png";
import { useNavigate, useLocation } from "react-router-dom";
import { useCreateCompanyMutation, useCreateAddressDetailsMutation, useCreateAddressMutation, useCreateWorldBoxOrderMutation, useGetCurrentUserQuery, useCreateWorldBoxCompanyMutation } from '../../../src/store/Company/companyApiSlice'
import { Modal, SessionExpired } from "../../../src/components/common";
import { clearUserInfo } from "../../../src/store/auth/authSlice";
import { useAddBillingAddressMutation } from "../../../src/store/Billing/billingApiSlice";
import { extractCountryCodeAndPhoneCode, getCountryCode, getStatesByCountryCode } from "../../utils/countriesState";
import { CommonToast } from "../../components/common/Toast";
import { PurchaseSuccess } from "../../components/common/PurchaseSuccess";
import PhoneNumberInput from "../../components/common/PhoneNumberInput";
import { isPossiblePhoneNumber } from "react-phone-number-input";
import { CreditNotice } from "../../components/common/CreditNotice";
import { selectActiveCompany } from "../../store/activeCompanySlice";
import { buildWebProfileSummary } from "../../constants/webProfilePricing";
import { Aed } from "../../components/common/Money";
import { DESIGNATION_MAX_LENGTH, validateDesignation } from "../../utils/designation";
export default function CreateCompany() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { token, userInfo } = useSelector((state) => state.auth);
  // TIP-493 — ordering a report is the same purchase as buying a web profile:
  // PAYG at the AED rate, with the member discount applied automatically for
  // members. (Stays on the PAYG path, not the bundle, because the report's
  // Worldbox creation is provisioned by the legacy invoice webhook.)
  const activeCompany = useSelector(selectActiveCompany);
  const reportMode = ["member", "verified"].includes(activeCompany?.profile_status)
    ? "member"
    : "payg";
  const reportSummary = buildWebProfileSummary({ mode: reportMode });
  const houseNoRef = useRef();
  const companyNameRef = useRef();
  const localityRef = useRef();
  const areaRef = useRef();
  const postalCodeRef = useRef();
  const emailRef = useRef();
  // const telephoneRef = useRef();
  const [mobile, setMobile] = useState('')
  const cityRef = useRef();
  const [description, setDescription] = useState("");
  const [countries, setCountries] = useState(getCountryCode());
  const [errors, setErrors] = useState({});
  const [states, setStates] = useState([]);
  const [selectedState, setSelectedState] = useState("");
  const [countryCode, setCountryCode] = useState("+971");
  const [selectedCountry, setSelectedCountry] = useState("");
  const [isSessionExpired, setSessionExpired] = useState(false);
  const [countryCodes, setCountryCodes] = useState(extractCountryCodeAndPhoneCode());
  const [createCompany] = useCreateCompanyMutation();
  const [addBillingAddress] = useAddBillingAddressMutation();
  const [createAddressDetails] = useCreateAddressDetailsMutation();
  const [setAddressConnection] = useCreateAddressMutation();
  const [userEnterprise, setUserEnterprise] = useState([]);
  const [subscriptionActive, setSubscriptionActive] = useState();
  const [selectedEnterprise, setSelectedEnterprise] = useState();
  //const [createOrderWorldBox] = useCreateWorldBoxOrderMutation();
  const [creditBanner, setCreditBanner] = useState(false);
  const [creditNoticePopup, setCreditNoticePopup] = useState(false);
  const [showCreditSuccessModal, setShowCreditSuccessModal] = useState(false)
  const [acknowledgedFormData, setAcknowledgedFormData] = useState({
    name: '',
    designation: '',
    email: '',
    contactNumber: '',
  });

  const [isAcknowledged, setIsAcknowledged] = useState(false);
  const { data, refetch } = useGetCurrentUserQuery({
    token,
  });

  useMemo(() => {
    const filteredEnterpriseForCredit = userInfo?.enterprise_solutions?.filter(({ credits }) => credits !== undefined && credits !== null && credits > 0);
    setUserEnterprise(filteredEnterpriseForCredit)
  }, [userInfo])

  const [createWorldBoxCompany, { isLoading: companyCreating }] = useCreateWorldBoxCompanyMutation()

  useEffect(() => {
    const SubscriptionActive = data?.individual[0]?.individualSubscription?.find(
      (sub) => (sub?.status === "active" && sub?.subscription_type != "pay-as-you-go")
    );

    setSubscriptionActive(SubscriptionActive)
    SubscriptionActive?.no_of_profile_views >= 1 ? setCreditBanner(true) : setCreditBanner(false)
  }, [data])

  const sessionExpiredPopup = () => {
    setSessionExpired(!isSessionExpired);
    dispatch(clearUserInfo());
    navigate("/login");
  };
  useEffect(() => {
    if (token == null) {
      setSessionExpired(true);

    }
  }, [token]);
  const handleCountryChange = (e) => {
    setSelectedCountry(e.target.value);
    const selectedCountryData = countries.find(
      (country) => country.countryCode === e.target.value
    );

    if (selectedCountryData) {
      let statesFn = async () => {
        const states = await getStatesByCountryCode(selectedCountryData?.countryCode)
        setStates(states);
      };
      statesFn();
    }
  };

  const handleStateChange = (e) => {
    const selectedState = e.target.value;
    setSelectedState(selectedState);

  };

  useEffect(() => {
    localStorage.removeItem('payasyougoCompanyID');
    localStorage.removeItem('worldboxData')
  }, [])

  // TIP-556 — arriving from the search "Company Not Found?" CTA carries the
  // failed search as router state: pre-fill the company name (uncontrolled
  // input, written via its ref) and the country (mirrors handleCountryChange).
  useEffect(() => {
    const prefill = location.state?.prefill;
    if (!prefill) return;
    if (prefill.companyName && companyNameRef.current) {
      companyNameRef.current.value = prefill.companyName;
    }
    if (prefill.countryCode && countries.some((c) => c.countryCode === prefill.countryCode)) {
      setSelectedCountry(prefill.countryCode);
      getStatesByCountryCode(prefill.countryCode).then(setStates);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const validateErrors = () => {
    const errors = {};
    if (houseNoRef.current.value.trim() === "") {
      errors.houseNo = "Address Line 1 is required.";
    }
    if (selectedState.trim() === "") {
      errors.state = "State is required.";
    }
    if (selectedCountry.trim() === "") {
      errors.country = "Country is required.";
    }
    if (companyNameRef.current.value.trim() === "") {
      errors.companyName = "Company Name is required.";
    }
    // TIP-562 — the backend hard-requires a truthy city for order creation
    // (createWorldBoxCompany raises otherwise); this was previously masked
    // because the payload's city key was silently filled by selectedState.
    if (cityRef.current.value.trim() === "") {
      errors.city = "City is required.";
    }
    if (mobile?.trim() === "") {
      errors.phoneNumberError = "Phone Number is required.";
    }
    if (!isPossiblePhoneNumber(mobile?.toString() ?? "")) {
      errors.phoneNumberError = "Enter valid mobile number";
    }
    if (emailRef.current.value.trim() === "") {
      errors.emailError = "Email is required.";
    }

    return errors
  }
  const payNow = async (type) => {
    const errors = validateErrors();
    setErrors(errors);
    if (Object.keys(errors).length === 0) {
      let customerreference;
      if (!isAcknowledged) {
        customerreference = 'No reference data provided';
      } else {
        customerreference = `Name: ${acknowledgedFormData.name},
      Designation: ${acknowledgedFormData.designation},
      Email: ${acknowledgedFormData.email},
      Contact: ${acknowledgedFormData.contactNumber || 'N/A'},`;
      }
      const companyDescription = {
        companyname: companyNameRef.current.value,
        // TIP-562 — kept for backward compatibility; real city now also sent
        // discretely below instead of only being buried in here.
        address1: houseNoRef.current.value + " " + localityRef.current.value + " " + areaRef?.current?.value + " " + cityRef?.current?.value + " " + selectedState,
        city: cityRef.current.value,
        state: selectedState,
        postal_code: postalCodeRef.current.value,
        email: emailRef.current.value,
        phone: mobile,
        comp_des: description,
        countrycode: selectedCountry,
        currency: "USD",
        payment_type: type,
        ...(isAcknowledged && { customerreference: customerreference }),
        ...(type === 'enterprise' && { enterpriseID: selectedEnterprise?.id })
      }
      if ((type === "credit" || type === "enterprise")) {
        try {
          const data = await createWorldBoxCompany({
            data: companyDescription,
            token: token,
          }).unwrap();
          if (data?.status === "ORDER_CREATED") {
            refetch();
            setShowCreditSuccessModal(true);
            setCreditNoticePopup(false)
            CommonToast.success(type === "credit" ? `Your order has been placed successfully with Order No.:${data.ordernumber}` : "Your order has been placed successfully")
          }
        } catch (error) {
          CommonToast.error(error?.data?.response ?? "Something went wrong")
        }
      } else {
        localStorage.setItem('companyDescription', JSON.stringify(companyDescription));
        localStorage.setItem('createWorldboxCompany', true)
        // TIP-556 — a report order has no companyID yet (the company is created
        // by the webhook after payment); reportRequest tells PaymentDetails to
        // skip its select-a-company guard. The old company_id here read a field
        // that doesn't exist on the user query and was always undefined.
        navigate("/plans/paymentdetails", {
          state: {
            planDetails: planDetails,
            reportRequest: true,
          },
        });
      }
    }

  }
  const planDetails = {
    title: "Web Profile",
    mode: reportMode, // TIP-493 — drives the AED web-profile checkout (payg/member)
    slug: "pay-as-you-go",
  };

  const handleNavigate = () => {
    setShowCreditSuccessModal(false);
    navigate(selectedEnterprise ? '/dashboard/enterprise' : '/dashboard/purchased')
  }

  // Designation is optional here, so only surface the standard word
  // restrictions once the user has typed something.
  const acknowledgedDesignationError = (acknowledgedFormData.designation || '').trim()
    ? validateDesignation(acknowledgedFormData.designation)
    : "";

  const handleAcknowledgedFormChange = (e) => {
    const { name, value } = e.target;
    setAcknowledgedFormData({ ...acknowledgedFormData, [name]: value });
  };

  const handlePhoneNumberValue = (value) => {
    setAcknowledgedFormData({ ...acknowledgedFormData, ["contactNumber"]: value });
  }

  const handleAcknowledgementChange = (e) => {
    setIsAcknowledged(e.target.checked);
  };

  const handlePurchase = () => {
    const errors = validateErrors();
    setErrors(errors);
    if (Object.keys(errors).length === 0) {
      setCreditNoticePopup(true)
    }
  }

  return (
    <>
      {
        creditNoticePopup && (
          <Modal modalHandle={() => setCreditNoticePopup(false)}>
            <p className="text-f20 font-semibold text-left">Get this business</p>
            {userEnterprise?.length > 0 && <p className="text-f16 text-gray-500 text-left">select how you want to proceed to buy this business</p>}
            <CreditNotice
              onclick={() => setCreditNoticePopup(false)}
              handlePurchased={payNow}
              NoCredits={!subscriptionActive || subscriptionActive?.no_of_profile_views == 0}
              title={
                subscriptionActive?.no_of_profile_views >= 1
                  ? "Attention!!"
                  : "Oopss..."
              }
              des={
                subscriptionActive?.no_of_profile_views >= 1
                  ? userEnterprise?.length > 0 ? `1 credit out of ${subscriptionActive?.no_of_profile_views
                    } credit(s)` : `You are about to use <b> 1 credit </b> for these request. You will be left with <b> ${subscriptionActive?.no_of_profile_views - 1
                    } more credit of this month </b>`
                  : "No credits Left"
              }
              des2={`Currently you have <b> ${subscriptionActive?.no_of_profile_views} Credit </b>. Upgrade your plan to get more credit or else continue via payment method`}
              leftButton={
                subscriptionActive?.no_of_profile_views >= 1
                  ? "Cancel"
                  : "Buy Credits"
              }
              userInfo={userInfo}
              rightButton={"Process"}
              selectedEnterprise={selectedEnterprise}
              setSelectedEnterprise={setSelectedEnterprise}
              userEnterprise={userEnterprise}
              handleNavigation={true}
            />
          </Modal>
        )
      }
      {showCreditSuccessModal && <Modal modalHandle={handleNavigate}>
        <PurchaseSuccess
          onclick={handleNavigate}
          title={"Business creation Successful"}
          des={"Enjoy the Incredible Experience of the businesses"}
          button={"continue"}
        />
      </Modal>}
      {isSessionExpired && <Modal modalHandle={sessionExpiredPopup}>
        <SessionExpired handleNavigate={sessionExpiredPopup} />
      </Modal>}
      <div className="mx-auto px-4 py-6 lg:px-8 bg-slate w-full">
        <Breadcrumb />
        <div className="grid md:grid-cols-4 lg:gap-4 md:gap-4 sm:gap-0 mb-4 grid-cols-1 max-w-7xl mx-auto">
          <div className="col-span-3 bg-white rounded-md p-4">
            <div className="flex justify-between p-5  w-full rounded-lg registerComp1">
              <div className="flex flex-col items-start">
                <h1 className="text-primary md:text-f24 sm:text-f18 text-f16 font-bold text-left flex sm:gap-4 gap-1 items-start justify-start">
                  <span className="max-w-lg">
                    Request Business
                  </span>
                </h1>
                <span className="createComp">Just provide us basic details of the business & we will create that business profile on our platform.</span>
              </div>
              <img src={requestcompany} alt="Request Business" />
            </div>
            <div className=" p-5  w-full rounded-lg registerComp">
              <div className="flex justify-start flex-colgap-4 w-full">
                <div className="mb-3 w-full">
                  <AuditFirm className="CompSvg" />
                  <Input
                    className="CompInput"
                    label="Full Business Name"
                    id="companyName"
                    inputRef={companyNameRef}
                    error={errors.companyName}
                    placeholder="Enter Business Name"
                  />
                </div>
              </div>
              <div className="flex gap-4 w-full">
                <div className="mb-3 w-full">
                  <MapPoint className="CompSvg" />
                  <Input
                    className="CompInput"
                    label="Business Address Line 1"
                    id="houseNo"
                    inputRef={houseNoRef}
                    error={errors.houseNo}
                    placeholder="Suite/Building/Floor No."
                  />
                </div>
                <div className="mb-3 w-full">
                  <MapPoint className="CompSvg" />
                  <Input
                    className="CompInput"
                    label="Business Address Line 2"
                    id="locality"
                    inputRef={localityRef}
                    error={errors.locality}
                    placeholder="Enter Street/Locality"
                  />
                </div>
              </div>
              <div className="flex gap-4 w-full">
                <div className="mb-3 w-full">
                  <MapPoint className="CompSvg" />
                  <Input
                    className="CompInput"
                    label="Area"
                    id="area"
                    inputRef={areaRef}
                    error={errors.area}
                    placeholder="Enter Area"
                  />
                </div>

                <div className="mb-3 w-full">
                  <Globus className="CompSvg" />
                  <Input
                    className="CompInput"
                    label="Postal Code"
                    id="postalCode"
                    inputRef={postalCodeRef}
                    error={errors.postalCodeError}
                    placeholder="Enter Postal Code"

                  />
                </div>
              </div>

              <div className="flex gap-4 w-full">
                <Select
                  label="Country"
                  id="country"
                  value={selectedCountry}
                  error={errors.country}
                  placeholder="Select a country"
                  onChange={handleCountryChange}
                >
                  <option value="">Select a country</option>
                  {countries
                    .sort((a, b) => a.countryName.localeCompare(b.countryName))
                    .map((country, index) => (
                      <option key={index} disabled={selectedCountry != '' ? true : false} value={country.countryCode}>
                        {country.countryName}
                      </option>
                    ))}
                </Select>
              </div>
              <div className="flex gap-4 w-full">
                {states?.length > 0 ? <Select
                  label="State"
                  id="state"
                  value={selectedState}
                  onChange={handleStateChange}
                  error={errors.state}
                  disable={!selectedCountry}
                  placeholder="Select a state"
                  className={!selectedCountry ? "cursor-not-allowed" : "default"}
                >
                  <option value="">Select a state</option>
                  {states?.map((state) => (
                    <option key={state.state_code} value={state.name}>
                      {state.name}
                    </option>
                  ))}
                </Select> : <Input
                  label="State"
                  id="state"
                  inputvalue={selectedState}
                  onInputChange={handleStateChange}
                  error={errors.state}
                  placeholder="Enter a state"
                  disable={!selectedCountry}
                  className={!selectedCountry ? "cursor-not-allowed" : "default"}
                />}
                <Input
                  label="City"
                  id="city"
                  inputRef={cityRef}
                  error={errors.city}
                  placeholder="Enter a City"
                />
              </div>
              <div className="flex gap-4 w-full">
                <div className="mb-3 w-full">
                  <Email className="CompSvg" />
                  <Input
                    className="CompInput"
                    label="Email Address"
                    id="email"
                    inputRef={emailRef}
                    error={errors.emailError}
                    placeholder="Email Address"
                  />
                </div>
                <div className="flex items-start flex-col relative w-full phoneInputCreateCompany">
                  <div className="flex items-start flex-col  w-full">
                    <label className="text-primary text-f14 font-semibold mb-1">
                      Phone
                    </label>
                    <div className="relative w-full mb-4">
                      <PhoneNumberInput
                        id="mobile"
                        phone={mobile}
                        border={true}
                        setPhone={setMobile}
                        verifyPhoneNumber={false}
                        classes={'addBackground'}
                        error={errors.phoneNumberError} />
                      {errors.phoneNumberError && <p className="text-red-500 text-sm text-left ">{errors.phoneNumberError}</p>}
                    </div>
                  </div>
                </div>
              </div>
              <label htmlFor="description" className="block mb-1 text-primary text-f14 font-semibold text-left">Description about business to easily identify (Optional)
                <div className="w-full border px-3  border-input focus:border-primary  py-2 border-input rounded bg-input ">
                  <textarea
                    id="description"
                    rows="4"
                    className="block w-full text-sm text-secondary bg-inputInterface bg-[#faf7f7]  outline-none"
                    placeholder="Write here..."
                    onChange={(e) => {
                      setDescription(e.target.value);
                    }}></textarea>
                </div>
              </label>
              <div className="my-4">
                <input
                  type="checkbox"
                  checked={isAcknowledged}
                  onChange={handleAcknowledgementChange}
                  id="acknowledgementCheckbox"
                />
                <label htmlFor="acknowledgementCheckbox" className="ml-2">Can we contact a business representative using your provided details to create a detailed report?</label>
              </div>

              {isAcknowledged && (
                <div className="form">
                  <User className="CompSvg" />
                  <Input
                    className="CompInput"
                    label="Name"
                    name="name"
                    value={acknowledgedFormData.name}
                    onInputChange={handleAcknowledgedFormChange}
                    placeholder="Enter Name"
                  />
                  <Designation className="CompSvg" />
                  <Input
                    className="CompInput"
                    label="Designation"
                    name="designation"
                    value={acknowledgedFormData.designation}
                    onInputChange={handleAcknowledgedFormChange}
                    maxLength={DESIGNATION_MAX_LENGTH}
                    error={acknowledgedDesignationError}
                    placeholder="Enter Designation"
                  />

                  <Email className="CompSvg" />
                  <Input
                    className="CompInput"
                    label="Email"
                    name="email"
                    value={acknowledgedFormData.email}
                    onInputChange={handleAcknowledgedFormChange}
                    placeholder="Enter email"
                  />
                  <div className="flex items-start flex-col relative w-full phoneInputCreateCompany">
                    <div className="flex items-start flex-col  w-full">
                      <label className="text-primary text-f14 font-semibold mb-1">
                        Phone
                      </label>
                      <div className="relative w-full mb-4">
                        <PhoneNumberInput
                          id="mobile"
                          phone={acknowledgedFormData.contactNumber}
                          border={true}
                          setPhone={handlePhoneNumberValue}
                          verifyPhoneNumber={false}
                          classes={'addBackground'}
                          error={errors.phoneNumberError} />
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
          <div className="sidebar">
            <div className="col-span-3 bg-white rounded-md p-4">
              <div className="flex justify-between p-5  w-full rounded-lg">
                <div className="flex flex-col items-start">
                  <h1 className="text-primary md:text-f24 sm:text-f18 text-f16 font-bold text-left flex sm:gap-4 gap-1 items-start justify-start">
                    <span className="max-w-lg">
                      Pay this amount
                    </span>
                  </h1>
                </div>
              </div>
              <div className=" p-5  w-full rounded-lg">
                <h3 className="text-primary sm:text-f18 text-f16 font-bold text-left flex sm:gap-4 gap-1 items-start justify-start">
                  <span className="max-w-lg">
                    Price Details
                  </span>
                </h3>
                <div>
                  <div className="pricingSec"><span className="sec1">Subtotal</span><span><Aed value={reportSummary.subtotal} /></span></div>
                  {reportMode === "member" && (
                    <div className="pricingSec"><span className="sec1">Member rate (10% off)</span><span className="text-[#1A8917]">applied</span></div>
                  )}
                  <div className="pricingSec"><span className="sec1">VAT</span><span>excluded</span></div>
                </div>
                <hr className="rulerSec" />
                <div className="pricingSec"><span className="sec1">Total (excl. VAT)</span><span>
                  <Aed value={reportSummary.subtotal} /></span></div>
                <p className="text-secondary text-f12 mt-1">VAT is added at the secure checkout.</p>
                <div>
                  <button onClick={() => { payNow('pay') }} className='payNow w-full bg-primary font-sans text-white p-2 rounded-md'>Pay</button>
                </div>

              </div>
            </div>
            {(creditBanner || userEnterprise?.length > 0) && <><div className="ORDIV">
              <hr className="rulerSec" />
              <span className="rulerSpan">OR</span>
              <hr className="rulerSec" />
            </div>
              <div
                className="text-left mt-5 lg:max-w-sm bg-white border border-gray-200 rounded-lg shadow"
                style={{
                  backgroundImage: `url(${CompanyNotFoundBg})`,
                  backgroundSize: `cover`,
                }}
              >
                <div className="p-5">
                  <h4 className="mb-2 text-2xl tracking-tight text-white text-f20 font-sans">
                    Use your Credit
                  </h4>
                  <p className="mb-3 font-light text-white text-f14 font-sans text-thin">
                    Use 1 credit to request this business.
                  </p>
                  <button
                    onClick={handlePurchase}
                    className='payCredit w-full bg-primary font-sans text-white p-2 rounded-md'>{companyCreating ? <Spinner /> : "Use Credit"}</button>
                </div>
              </div>
            </>}
          </div>
        </div>
      </div>
    </>
  );
}
